import { makeStyles } from "tss-react/mui";
import { INSPECTION_STATUSES_CONFIG } from "@miplatform/constants";
import { getDefaultDate } from "@miplatform/utils";
import { Box, Divider, Typography, useTheme } from "@mui/material";

export const InspectionDrawerHeader = ({
  status,
  scheduledDate,
  attemptNumber = 1,
  inspectedDate,
  reportedDate,
}: {
  status?: string;
  scheduledDate?: string;
  attemptNumber?: number;
  inspectedDate?: string;
  reportedDate?: string;
}) => {
  const theme = useTheme();

  const {
    backgroundColor = theme.palette.grey[100],
    color = theme.palette.grey[300],
  } =
    INSPECTION_STATUSES_CONFIG[
      status as keyof typeof INSPECTION_STATUSES_CONFIG
    ] ?? {};

  const { classes, cx } = useStyles({ backgroundColor, color });

  return (
    <Box>
      <Box className={classes.statusCard}>
        <Box className={cx(classes.statusCell, classes.detailCell)}>
          <Typography variant="BD1" color={theme.palette.grey[600]}>
            Status
          </Typography>
          <Typography variant="HD1" color={color}>
            {status ?? "-"}
          </Typography>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ backgroundColor: color }}
        />
        <Box className={classes.detailRow}>
          <Box className={cx(classes.firstCell, classes.detailCell)}>
            <Typography variant="BD1" color={theme.palette.grey[600]}>
              Scheduled Date
            </Typography>

            <Typography variant="HD1">
              {getDefaultDate(scheduledDate)}
            </Typography>
          </Box>
          <Box className={classes.detailCell}>
            <Typography variant="BD1" color={theme.palette.grey[600]}>
              Attempt #
            </Typography>
            <Typography variant="HD1" textAlign="center">
              {attemptNumber ?? "-"}
            </Typography>
          </Box>

          <Box className={classes.detailCell}>
            <Typography variant="BD1" color={theme.palette.grey[600]}>
              Inspected On
            </Typography>
            <Typography variant="HD1">
              {getDefaultDate(inspectedDate)}
            </Typography>
          </Box>

          <Box className={classes.detailCell}>
            <Typography variant="BD1" color={theme.palette.grey[600]}>
              Resulted
            </Typography>
            <Typography variant="HD1">
              {getDefaultDate(reportedDate)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles<{
  backgroundColor: string;
  color: string;
}>()((theme, { backgroundColor, color }) => ({
  headerAddress: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  statusCard: {
    display: "flex",
    margin: theme.spacing(2, 0),
    borderRadius: 2,
    border: `1px solid ${color}`,
    backgroundColor,
    height: 48,
  },
  detailRow: {
    display: "flex",
    flex: 1,
    gap: theme.spacing(4),
  },
  detailCell: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    justifyContent: "center",
  },
  firstCell: {
    paddingLeft: theme.spacing(4),
  },
  statusCell: {
    backgroundColor: `rgba(0, 60, 72, 0.1)`,
    padding: theme.spacing(0, 4),
  },
  redTag: {
    color: theme.palette.error.main,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    fontWeight: 600,
    fontSize: 12,
  },
  templateBadgeContainer: {
    display: "flex",
    alignItems: "center",
  },
}));
